import React, { useState } from "react";
import { PlayerBar, QueuePanel, Toast } from "../designSystem";
import { usePlayer } from "./PlayerContext";

/** 常驻底部播放条 + 播放列表浮层 + 全局 Toast。没有加载单集时只保留 Toast。 */
export default function GlobalPlayerBar() {
  const player = usePlayer();
  const [queueOpen, setQueueOpen] = useState(false);

  const queueItems = player.queue.map((ep) => ({
    id: ep.id,
    title: ep.title,
    duration: ep.durationSec,
  }));

  return (
    <>
      {player.episode ? (
        <>
          <div className="lt-player-spacer" />
          <PlayerBar
            episode={{
              id: player.episode.id,
              title: player.episode.title,
              vol: player.episode.vol,
              cover: `${process.env.PUBLIC_URL}/logo192.png`,
              memberOnly: player.episode.memberOnly,
            }}
            playing={player.playing}
            currentTime={player.currentTime}
            duration={player.duration}
            speed={player.speed}
            timer={player.timer}
            queueOpen={queueOpen}
            onToggle={player.toggle}
            onSkip={player.skip}
            onNext={player.next}
            onSeek={player.seek}
            onSpeedChange={player.setSpeed}
            onTimerChange={player.setTimer}
            onQueueToggle={() => setQueueOpen((v) => !v)}
          />
          {queueOpen ? (
            <div className="lt-queue-pop">
              <QueuePanel
                items={queueItems}
                currentId={player.episode.id}
                playing={player.playing}
                onSelect={player.queueSelect}
                onRemove={player.queueRemove}
                onClose={() => setQueueOpen(false)}
              />
            </div>
          ) : null}
        </>
      ) : null}
      <Toast open={!!player.toastMsg} variant={player.toastVariant || "success"}>
        {player.toastMsg}
      </Toast>
    </>
  );
}
